export default __webpack_public_path__ + "static/media/kap-arrow.119f9fd0.svg";